"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentItemPerformance = void 0;
/**
 * This represents student item latest performance details
 */
var StudentItemPerformance = /** @class */ (function () {
    function StudentItemPerformance(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    Object.defineProperty(StudentItemPerformance.prototype, "isCorrect", {
        get: function () {
            return this.maxScore === this.score;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StudentItemPerformance.prototype, "isPartiallyCorrect", {
        get: function () {
            return this.score < this.maxScore && this.score !== 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StudentItemPerformance.prototype, "isIncorrect", {
        get: function () {
            return this.score === 0;
        },
        enumerable: false,
        configurable: true
    });
    return StudentItemPerformance;
}());
exports.StudentItemPerformance = StudentItemPerformance;
